import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import {endpoints} from "@api/apis";

export const kycSummaryInitiate = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.kycSummaryInit}${applicationId}`);
}
export const kycSummaryEnhanceLimit = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.kycSummaryEdit}${applicationId}`);
}

export const kycSummaryUpdate = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.post(`${endpoints.updateUserKYC}${applicationId}`);
}

export const kycSummaryVerify = async (payload: {
    applicationId: string;
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.get(`${endpoints.kycSummaryVerify}${applicationId}`);
}
